import { render } from "./Interno_sap.vue?vue&type=template&id=3290309d&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./Interno_sap.vue?vue&type=script&lang=js"
export * from "./Interno_sap.vue?vue&type=script&lang=js"

import "./Interno_sap.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script